var map = {
	"./01_Dreier Frenzel_Immeuble Verdeaux Renens_Gebaeude.jpg": 8981,
	"./02_Dreier Frenzel_Immeuble Verdeaux Renens_Innenraum.jpg": 7569,
	"./03_Dreier Frenzel_Immeuble Verdeaux Renes_Obergeschoss.jpg": 3033,
	"assets/b5_renes/01_Dreier Frenzel_Immeuble Verdeaux Renens_Gebaeude.jpg": 8981,
	"assets/b5_renes/02_Dreier Frenzel_Immeuble Verdeaux Renens_Innenraum.jpg": 7569,
	"assets/b5_renes/03_Dreier Frenzel_Immeuble Verdeaux Renes_Obergeschoss.jpg": 3033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;